module.exports = __webpack_public_path__ + "static/img/card04.d2d1a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/card04.png
// module id = 275
// module chunks = 6